module.exports = __webpack_public_path__ + "img/W-S11.adc5f5a2.jpg";